<template>
  <div id="search">
    <b-container id="search--top">
      <booking-engine size="sm" />
    </b-container>

    <b-container id="search--content">
      <div v-if="loading" class="text-center">
        <!--<b-spinner />-->
        <loader class="mt-4" :show_timing_slot="true" />
      </div>
      <b-row v-else>
        <b-col sm="12" md="3" xl="2">
          <div>
            <filters :filtered_all_carriers="filtered_flights.filtered_all_carriers" />
          </div>
        </b-col>
        <b-col sm="12" md="9" xl="10">
          <div class="flightoffer" v-if="Object.keys(this.$store.state.liveflight.results).length">
            <div class="flightoffer--wrap" v-if="filtered_flights.filtered">
              <div v-if="filtered_flights.filtered.length == 0">
                <no-results />
                <no-results-suggestions />
              </div>
              <div v-else>
                <filters-tags />
                <best-picks
                  v-if="!has_filters && Object.keys(best_picks).length > 0"
                  :options="best_picks"
                />
                <DynamicScroller
                  page-mode
                  ref="resultsListScroller"
                  :items="filtered_flights.filtered"
                  :item-size="null"
                  :min-item-size="100"
                  key-field="id"
                  class="scroller"
                >
                  <template v-slot="{ item, index, active }">
                    <DynamicScrollerItem
                      :item="item"
                      :data-index="index"
                      :class="'flight--pad-' + index"
                      :active="active"
                    >
                      <flight-pad
                        :flight_offer="item"
                        :flight_offer_index="index"
                        :is_best="
                          Object.keys(best_picks).reduce(
                            (list, pick) =>
                              best_picks[pick].flight_offer_id === item.id ? [...list, pick] : list,
                            []
                          )
                        "
                        selectable
                      />
                    </DynamicScrollerItem>
                  </template>
                </DynamicScroller>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import BookingEngine from '@/components/blocks/booking-engine';
import FlightPad from '@/components/blocks/flight-pad/flight-pad';
import Filters from '@/components/blocks/filters';
import FiltersTags from '@/components/blocks/filters-tags';
import NoResults from '@/components/blocks/no-results';
import NoResultsSuggestions from '@/components/blocks/no-results-suggestions';
import { filter_flight_offers, are_filters_active } from '@/utilities/filters';
import Loader from '@/components/blocks/loader';
import { custom_event, parse_flight_offer_for_ecommerce_item } from '@/utilities';
import BestPicks from '@/components/blocks/flight-pad/best-picks/best-picks.vue';
import { sort_flight_offers } from '@/utilities/sorting';

export default {
  name: 'liveflight-search',
  components: {
    'flight-pad': FlightPad,
    'booking-engine': BookingEngine,
    filters: Filters,
    'filters-tags': FiltersTags,
    'no-results': NoResults,
    'no-results-suggestions': NoResultsSuggestions,
    loader: Loader,
    'best-picks': BestPicks,
  },
  props: {},
  watch: {},
  computed: {
    filter_round_trip_departure: {
      get() {
        return this.$store.state.liveflight.filter_round_trip_departure;
      },
      set() {
        //
      },
    },
    filter_round_trip_arrival: {
      get() {
        return this.$store.state.liveflight.filter_round_trip_arrival;
      },
      set() {
        //
      },
    },
    filter_carriers: {
      get() {
        return this.$store.state.liveflight.filter_carriers;
      },
      set() {
        //
      },
    },
    offers: {
      get() {
        return this.$store.state.liveflight.results.offers;
      },
      set() {},
    },
    best_picks: {
      get() {
        return this.$store.state.liveflight.results.best_picks || {};
      },
      set() {},
    },
    loading: {
      get() {
        return this.$store.state.liveflight.loading;
      },
      set() {},
    },
    has_filters() {
      return are_filters_active();
    },
    filtered_flights: {
      get() {
        let filtered_flights = filter_flight_offers(),
          filtered = sort_flight_offers(
            filtered_flights.filtered,
            (this.best_picks['best'] || {}).rankings || {}
          );

        custom_event({
          event: 'view_item_list',
          ecommerce: {
            currency: 'EUR',
            items: this.parseGa4EcommerceItems(filtered),
            transaction_id: '',
            affiliation: '',
            value: 0, // Sum of (price * quantity) for all items.
            tax: 0,
            shipping: 0,
            coupon: '',
          },
        });

        return {
          filtered: filtered,
          filtered_all_carriers: filtered_flights.filtered_all_carriers,
        };
      },
      set() {},
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    parseGa4EcommerceItems(results) {
      // results = filtered
      const items = [];
      results.forEach((flightOffer) => {
        items.push(parse_flight_offer_for_ecommerce_item(flightOffer));
      });
      return items;
    },
  },
};
</script>

<style lang="scss">
#search {
  // #search--top {
  //     position:relative;
  //     z-index:10;
  // }
  #search--content {
    position: relative;

    @at-root .overflow-hidden & {
      z-index: 1;
    }
  }
  .flightoffer--itineraries {
    // altezza box per compensare pulsante prezzo
    height: inherit;
    // &>div,
    // &>div > .flightoffer--itinerary
    // {
    //     height:100%;
    // }
  }
}

div[class^='flight--pad'] {
  background: transparent;
}

.flightoffer--wrap {
  background-color: white;
  padding: $grid-gutter-width / 4;

  @include media-breakpoint-up(lg) {
    border-radius: 10px;
    padding: $grid-gutter-width / 2;
  }
}
</style>
